// extracted by mini-css-extract-plugin
export default {"faq":"Faq_faq__LZS7B","container":"Faq_container__qI9yi","containerTitle":"Faq_containerTitle__2aiTE","default":"Faq_default__E0rWY"};